import React from 'react';
import styles from './index.module.scss';
import { useScrollTrigger } from '@/hooks/useScrollTrigger';

// 第六屏：可视化展示核心支撑技术
export default function Screen6() {
  const rootRef = useScrollTrigger({
    triggerClass: styles['screen6-anim-start'],
    triggerRatio: 0.5,
    scrollContainerSelector: '.aixue-home-scroll',
    enableResizeDetection: true
  });
  return (
    <section className={styles['screen6-cover']} ref={rootRef}>
      <div className={styles['screen6-wrap']}>
        {/* 标题 */}
        <div className={styles['screen6-title-wrap']}>
          <h2 className={styles['screen6-title']}>AI核心技术</h2>
        </div>

        {/* 三列卡片 */}
        <div className={styles['screen6-flex']}>
          <div className={styles['screen6-flex-inner']}>
            {/* 卡片1：高并发 */}
            <div
              className={`${styles['screen6-card']} ${styles['screen6-card-1']}`}
            >
              <div className={styles['screen6-icon']}></div>
              <div className={styles['screen6-text']}>
                <div className={styles['screen6-title-sm']}>高并发</div>
                <div className={styles['screen6-sub-sm']}>支持万人并发，系统稳定性高</div>
              </div>
            </div>

            {/* 卡片2：低延时 */}
            <div
              className={`${styles['screen6-card']} ${styles['screen6-card-2']}`}
            >
              <div className={styles['screen6-icon']}></div>
              <div className={styles['screen6-text']}>
                <div className={styles['screen6-title-sm']}>低延时</div>
                <div className={styles['screen6-sub-sm']}>200FPS端云协同推理</div>
              </div>
            </div>

            {/* 卡片3：全适配 */}
            <div
              className={`${styles['screen6-card']} ${styles['screen6-card-3']}`}
            >
              <div className={styles['screen6-icon']}></div>
              <div className={styles['screen6-text']}>
                <div className={styles['screen6-title-sm']}>全适配</div>
                <div className={styles['screen6-sub-sm']}>中端手机到高端VR无缝覆盖</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
